import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import {
  DateRangePicker,
  type DateRangePickerProps,
  type DateRangeValueType,
  type IOption,
  Operator,
} from '@wf/components';

const operators = [Operator.exactDate, Operator.dateRange, Operator.beforeTheDate, Operator.afterTheDate];

const options: IOption[] = [
  {
    date: new Date(),
    operator: Operator.exactDate,
    label: 'Today',
  },
  {
    date: new Date(Date.now() - 24 * 60 * 60 * 1000),
    operator: Operator.exactDate,
    label: 'Yesterday',
  },
  {
    startDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    endDate: new Date(),
    label: 'Last 3 Days',
  },
  {
    startDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
    endDate: new Date(),
    label: 'Last 5 Days',
  },
  {
    startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    endDate: new Date(),
    label: 'Last Week',
  },
  {
    startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
    endDate: new Date(),
    label: 'Last Month',
  },
];

function DateRangeField({ onChange, startDate, endDate, date, selectedOperator, ...rest }: DateRangePickerProps) {
  const { t } = useTranslation();

  const [value, setValue] = useState<DateRangeValueType>({
    date,
    startDate,
    endDate,
    operator: selectedOperator ?? Operator.dateRange,
  });

  const handleChange = (value: DateRangeValueType) => {
    const newValue: DateRangeValueType = { ...value, operator: value.operator ?? Operator.dateRange };
    setValue(newValue);

    onChange(newValue);
  };

  return (
    <DateRangePicker
      placeholderText={t('Select date(s)')}
      selectedOperator={value?.operator}
      startDate={value?.startDate}
      endDate={value?.endDate}
      onChange={handleChange}
      operators={operators}
      date={value?.date}
      options={options}
      inline
      {...rest}
    />
  );
}

export default DateRangeField;
